import { fontStyles } from 'styles/theme';
import styled from '@emotion/styled';

export default styled.div({
  fontSize: fontStyles.sizes.sm,
});
